/**
 * Created by linjianxi on 2017/6/8.
 */
import * as actions from './actions'
import * as getters from './getter'
import * as types from './mutation-type'

const state = {
  dataGrid: {},
  cashData: [],
  cData: [],
  virtualData: [],
  vData: []
}
const mutations = {
  [types.GETUSERCASHMONTH] (state, res) {
    state.dataGrid = res.data
  },
  [types.CASHDETAILLIST] (state, source) {
    state.cashData = source.res.data
    if (source.res.data.Data == null) {
      state.cData = []
    } else {
      if (source._this.pageCashCount > 1) {
        state.cData = state.cData.concat(source.res.data.Data)
      } else {
        state.cData = source.res.data.Data
      }
    }
  },
  [types.VIRTUALLIST] (state, source) {
    state.virtualData = source.res.data
    if (source._this.pageLangPCount > 1) {
      state.vData = state.vData.concat(source.res.data.ResultDate)
    } else {
      state.vData = source.res.data.ResultDate
    }
  }
}
export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/hqpord_detail/store.js